<div class="wrapper">
	<button class="close" (click)="closeAndDestroy()">
		<i class="fa-light fa-xmark"></i>
	</button>
	<div class="header">
		<h1>{{ 'DISPLAYENDUSER.MODALHEADER' | translate }}</h1>
	</div>
	<div class="content">
		<div class="element">
			<h3>
				{{ 'DISPLAYENDUSER.ENDUSERHEADER' | translate }}
			</h3>
			<div [innerHTML]="'DISPLAYENDUSER.ENDUSERINFO' | translate">
			</div>
		</div>
		<div class="element">
			<h3>
				{{ 'DISPLAYENDUSER.DISPLAYHEADER' | translate }}
			</h3>
			<div [innerHTML]="'DISPLAYENDUSER.DISPLAYINFO' | translate">
			</div>
		</div>
	</div>
</div>